export default "__VITE_ASSET__DltrOmJ7__"